/* ==========================================================================
   ModalRxjs > Client > Prototype
   ========================================================================== */

/* Modules */
const { Store } = require('@bluekiri/alexandria/helpers/state');

const { fromEvent, merge } = require('rxjs');
const { filter, take, tap } = require('rxjs/operators');

const { actions, types } = require('./store/actions');
const { reducer } = require('./store/reducer');

const ESCAPE_CODE = 27;

/* Prototype */
const prototype = {
    /* Setup store */
    setupStore() {
        if (this.store) return this;

        this.store = new Store({
            modal: reducer
        });

        return this;
    },
    /* Setup actions */
    setupActions() {
        if (this.actions) return this;

        this.actions = {
            destroy: () => this.store.dispatch(actions.destroy()),
            display: () => this.store.dispatch(actions.display()),
            hide: () => this.store.dispatch(actions.hide())
        };

        return this;
    },
    /* Setup reactions */
    setupReactions() {
        if (this.reactions) return this;

        this.reactions = {
            destroy: this.store.subscribe((state, action) => {
                if (action.type !== types.DESTROY) return;

                /* Data */
                const { hasClose } = this.config;

                /* close */
                if (hasClose) {
                    this.close.actions.destroy();
                }

                /* Unsubscribe */
                [...Object.keys(this.reactions)].forEach(key => this.reactions[key].unsubscribe());

                /* Clean DOM */
                this.element.parentNode.removeChild(this.element);

                /* Clean reference */
                [...Object.keys(this)].forEach(key => delete this[key]);
            }),
            display: this.store.subscribe((state, action) => {
                if (action.type !== types.DISPLAY) return;

                /* Styles */
                const { css } = this.config;

                /* Update UI */
                this.element.classList.add(css.visible);
                document.body.classList.add(css.modalVisible);
            }),
            hide: this.store.subscribe((state, action) => {
                if (action.type !== types.HIDE) return;

                /* Styles */
                const { css } = this.config;

                /* Update UI */
                this.element.classList.remove(css.visible);
                document.body.classList.remove(css.modalVisible);
            })
        };

        return this;
    },
    /* Setup events */
    setupEvents() {
        if (this.events) return this;

        /* Data */
        const { hasClose } = this.config;

        /* Window clicks */
        const windowClick$ = fromEvent(window.document, 'click').pipe(
            filter(({ target }) => !target.closest('[data-modal-wrapper]'))
        );

        /* Clicks merged */
        const mergedClick$ = hasClose ? merge(this.close.events.click$, windowClick$) : windowClick$;

        /* Events */
        this.events = {
            click$: mergedClick$.pipe(
                take(1),
                tap(event => event.stopPropagation())
            ),
            keyup$: fromEvent(window.document, 'keyup').pipe(
                filter(event => event.keyCode === ESCAPE_CODE),
                take(1)
            )
        };

        return this;
    },
    /* Init */
    init() {
        if (!this.config.init) return this;

        /* Setup store */
        this.setupStore();

        /* Setup actions */
        this.setupActions();

        /* Setup reactions */
        this.setupReactions();

        /* Setup events */
        this.setupEvents();

        return this;
    }
};

/* Exports */
module.exports = prototype;
